import React, { useState, useEffect } from "react";
//style
import "./styled.css";
//redux
import { connect } from "react-redux";

import { Outlet, Link, useLocation } from "react-router-dom";

import { AiFillCloseCircle, AiOutlineMenu } from "react-icons/ai";

function Menu(props) {
  const [menu, setMenu] = useState(false);
  const [zoom, setZoom] = useState();
  const [theme, setTheme] = useState("");
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  function changeZoom() {
    document.body.style.zoom = zoom;
  }

  function changeTheme(e) {
    setTheme(e);
  }

  function redirectLink(link) {
    window.location = link;
  }

  useEffect(() => {
    if (!props.state.token) {
      window.open("/", "_parent");
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, "1000");
  }, []);

  useEffect(() => {
    changeZoom();
  }, [zoom]);
  // if (loading) {
  //   return <div>Carregando...</div>;
  // } else
  return (
    <div className={theme}>
      {/* menu web */}
      <div className="menu-accessibility-web">
        <div style={{ marginRight: 10 }}>
          <label className="label-accessibility">Opções de Contraste</label>
          <select
            onChange={(e) => changeTheme(e.target.value)}
            tabIndex={1}
            title="Selecione uma opção de acessibilidade"
          >
            <option value={""}>Padrão</option>
            <option value={"theme-gray-scale"}>Escala Cinza</option>
            <option value={"theme-contraste"}>Contraste</option>
            <option value={"theme-inverse"}>Cores Invertidas</option>
            <option value={"theme-monochrome"}>Monocromático</option>
          </select>
        </div>
        <div>
          <label className="label-accessibility">Zoom</label>
          <select
            onChange={(e) => setZoom(e.target.value)}
            tabIndex={2}
            title="Selecione uma opção de zoom"
          >
            <option value={""}>Padrão</option>
            <option value={"200%"}>200%</option>
            <option value={"400%"}>400%</option>
          </select>
        </div>
      </div>
      <div className="menu-home">
        <Link
          className={`${location.pathname === "/home"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home"
          tabIndex={3}
        >
          Home
        </Link>
        <Link
          className={`${location.pathname === "/home/palco"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/palco"
          tabIndex={4}
        >
          Palco Principal
        </Link>
        <Link
          className={`${location.pathname === "/home/expo-area"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/expo-area"
          tabIndex={5}
        >
          Expo Área
        </Link>
        <Link
          className={`${location.pathname === "/home/palco2"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/palco2"
          tabIndex={6}
        >
          Palco 2
        </Link>
        <Link
          className={`${location.pathname === "/home/casa-do-mascote"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/casa-do-mascote"
          tabIndex={7}
        >
          Casa do Mascote
        </Link>
        <Link
          className={`${location.pathname === "/home/talent-brand-store"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/talent-brand-store"
          tabIndex={8}
        >
          Talent Brand Store
        </Link>
        <Link
          className={`${location.pathname === "/home/conheca-escritorio"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/conheca-escritorio"
          tabIndex={9}
        >
          Conheça nossos escritórios
        </Link>
        {/* <Link
          className={`${
            location.pathname === "/home/repositorio-materiais"
              ? "menu-option-selected"
              : "menu-option"
          }`}
          to="/home/repositorio-materiais"
          tabIndex={10}
        >
          Repositório de materiais
        </Link> */}
        <Link
          className={`${location.pathname === "/home/descompression-room"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/descompression-room"
          tabIndex={11}
        >
          Sala de Descompressão
        </Link>
        <Link
          className={`${location.pathname === "/home/ranking"
            ? "menu-option-selected"
            : "menu-option"
            }`}
          to="/home/ranking"
          tabIndex={12}
        >
          Ranking
        </Link>
      </div>

      {/* menu mobile */}
      {!menu ? (
        <button
          className="div-icons-menu"
          style={{
            padding: 10,
            backgroundColor: "white",
            margin: 5,
            position: "fixed",
            right: 15,
            top: 15,
            borderRadius: 40,
            zIndex: 1000,
            border: "none",
          }}
          title="Abrir menu"
          onClick={() => setMenu(true)}
          tabIndex={1}
        >
          <i className="bx bx-menu" style={{ fontSize: 40 }} />
        </button>
      ) : (
        <button
          className="div-icons-menu"
          style={{
            margin: 10,
            position: "fixed",
            right: 10,
            top: 10,
            zIndex: 50,
            backgroundColor: "white",
            borderRadius: 40,
            padding: "0 10px",
            height: 60,
            border: "none",
          }}
          title="Fechar Menu"
          onClick={() => setMenu(false)}
          tabIndex={1}
        >
          <i className="mdi mdi-close-thick" style={{ fontSize: 40 }} />
        </button>
      )}
      <div
        className="menu-home-mobile"
        style={{
          left: menu ? "0%" : "100%",
        }}
      >
        <div className="menu-accessibility-mobile">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h1
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 45,
                marginBottom: 20,
              }}
            >
              Menu
            </h1>
            <label className="label-accessibility">Opções de Contraste</label>
            <select
              onChange={(e) => changeTheme(e.target.value)}
              className="input-accessibility"
              tabIndex={!menu && -1}
            >
              <option value={""}>Contraste Padrão</option>
              <option value={"theme-gray-scale"}>Escala Cinza</option>
              <option value={"theme-contraste"}>Contraste</option>
              <option value={"theme-inverse"}>Cores Invertidas</option>
              <option value={"theme-monochrome"}>Monocromático</option>
            </select>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label className="label-accessibility">Zoom</label>
            <select
              onChange={(e) => setZoom(e.target.value)}
              className="input-accessibility"
              tabIndex={!menu && -1}
            >
              <option value={""}>Zoom Padrão</option>
              <option value={"150%"}>150%</option>
              <option value={"200%"}>200%</option>
            </select>
          </div>
        </div>
        <div className="div-options-menu-mobile">
          <button
            className={`${location.pathname === "/home"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home");
            }}
            tabIndex={!menu && -1}
          >
            Home
          </button>

          <button
            className={`${location.pathname === "/home/palco"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/palco");
            }}
            tabIndex={!menu && -1}
          >
            Palco Principal
          </button>

          <button
            className={`${location.pathname === "/home/expo-area"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/expo-area");
            }}
            tabIndex={!menu && -1}
          >
            Expo Área
          </button>

          <button
            className={`${location.pathname === "/home/palco2"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/palco2");
            }}
            tabIndex={!menu && -1}
          >
            Palco 2
          </button>

          <button
            className={`${location.pathname === "/home/casa-do-mascote"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/casa-do-mascote");
            }}
            tabIndex={!menu && -1}
          >
            Casa do Mascote
          </button>

          <button
            className={`${location.pathname === "/home/talent-brand-store"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/talent-brand-store");
            }}
            tabIndex={!menu && -1}
          >
            Talent Brand Store
          </button>

          <button
            className={`${location.pathname === "/home/conheca-escritorio"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/conheca-escritorio");
            }}
            tabIndex={!menu && -1}
          >
            Conheça Nossos Escritórios
          </button>

          {/* <button
            className={`${location.pathname === "/home/repositorio-materiais"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/repositorio-materiais");
            }}
            tabIndex={!menu && -1}
          >
            Repositório de Materiais
          </button> */}

          <button
            className={`${location.pathname === "/home/descompression-room"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/descompression-room");
            }}
            tabIndex={!menu && -1}
          >
            Sala de Descompressão
          </button>

          <button
            className={`${location.pathname === "/home/ranking"
              ? "menu-option-selected"
              : "menu-option"
              }`}
            onClick={() => {
              setMenu(false);
              redirectLink("/home/ranking");
            }}
            tabIndex={!menu && -1}
          >
            Ranking
          </button>
        </div>
      </div>
      <Outlet />
    </div>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Menu);
